import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface AskChip {
  label: string;
  message: string;
}

// Sticky "Ask {agent}" bar (specs/ai-agent-home-redesign US-9): header row with the agent name
// and current context, prompt chips, and the parent's existing input row projected below
// (recording, attachments and send stay in the parent).
@Component({
  selector: 'app-agent-ask-bar',
  templateUrl: './agent-ask-bar.component.html',
  styleUrls: ['./agent-ask-bar.component.scss'],
})
export class AgentAskBarComponent {
  @Input() agentName = '';
  @Input() context = '';
  @Input() chips: AskChip[] = [];
  @Output() chipSelected = new EventEmitter<string>();
}
